// interfaces / types / consts
let PRV_URL_IDX = -1;
const BASE_URLS = JSON.parse(process.env.REACT_APP_AUTOTASK_RELAYER_URLS as string) || [];
type IAPI_RESPONSE = { result: string; status?: string; message?: string };

// exports
export const post = (body: object, walletId: number): Promise<string> => {
  const totalUrls = BASE_URLS.length;
  let urlIdx = 0;
  if (totalUrls && PRV_URL_IDX !== -1) {
    urlIdx = (PRV_URL_IDX + 1) % totalUrls;
  } else if (totalUrls) {
    urlIdx = walletId % totalUrls;
  }
  PRV_URL_IDX = urlIdx;
  return fetch(BASE_URLS[urlIdx] || '', {
    method: 'POST',
    body: JSON.stringify(body),
    headers: { 'Content-Type': 'application/json' }
  }).then((response) => response.json())
    .then((response: IAPI_RESPONSE) => {
      if (response.result) { return JSON.parse(response.result).txHash; }
      return Promise.reject(new Error(response.message || ''));
    });
};

export default { post };
